import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <img src="/css/buzzminded logo 3.jpg.jpeg" alt="BuzzMinded Logo" style={{ height: '70px', objectFit: 'contain', mixBlendMode: 'screen', filter: 'contrast(1.5) brightness(0.8)' }} />
        </div>

        {/* Mobile Menu Toggle */}
        <div className={`mobile-toggle ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation Links and CTA */}
        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <ul className="navbar-links">
            <li><a href="#home" className="active" onClick={() => setIsOpen(false)}>Home</a></li>
            <li><a href="#services" onClick={() => setIsOpen(false)}>Services</a></li>
            <li><a href="#portfolio" onClick={() => setIsOpen(false)}>Work</a></li>
            <li><a href="#process" onClick={() => setIsOpen(false)}>Process</a></li>
            <li><a href="#faq" onClick={() => setIsOpen(false)}>FAQ</a></li>
          </ul>

          <div className="navbar-actions">
            <button className="btn-primary" onClick={() => { setIsOpen(false); window.open('https://wa.me/917227095393', '_blank'); }}>Book A Discovery Call</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
